<template src="./manualConciliation.pug" lang="pug"></template>

<script>
import _ from 'underscore'
import vSelect from 'vue-select'
import { VueTabs, VTab } from 'vue-nav-tabs'
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import Modal from '../../../modals/modal/Modal'
import TabAllotment from '../../../modals/gridDetailsModal/tabAllotment/TabAllotment'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import PendingConciliations from '../../../reports/manualConciliation/PendingConciliations'
import Allotment from '../../../reports/manualConciliation/Allotment.vue'
import SelectedEntries from '../../../reports/manualConciliation/SelectedEntries'
import language from '../../../../../build/language/index'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'

export default {
  name: 'ManualConciliation',

  components: {
    vSelect,
    VueTabs,
    VTab,
    MultiSelectModal,
    Modal,
    TabAllotment,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    InputEstablishment,
    ButtonPrimary,
    PendingConciliations,
    Allotment,
    SelectedEntries
  },

  data () {
    return {
      establishimentsUrls: {
        establishments: 'manualConciliation/establishment/list',
        attributes: '/manualConciliation/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      messageExit: '',
      confirmExit: function (e) {
        let message = this.messageExit
        e = e || window.event
        // For IE and Firefox
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      },
      CONCILIATION_PLAN_MODAL: 'conciliationPlanModal',
      BANK_ACCOUNT_MODAL: 'bankAccountsModal',
      CATEGORIES_MODAL: 'categoriesModal',
      dateRange: {},
      itensSelected: [],
      list: [],
      selectedList: [],
      selectedStatuses: [],
      idPlanSelected: null,
      plansSelected: [],
      plansTags: [],
      firstDate: new Date(),
      finalDate: new Date(),
      dataTableColumns: [],
      dataTableOptions: {
        perPage: 5,
        perPageValues: [],
        texts: { count: this.$t('dataTable.labels.contagem'), noResults: this.$t('dataTable.labels.semResultados'), filter: '', filterPlaceholder: this.$t('dataTable.labels.filtrar') },
        filterable: true,
        pagination: {
          chunk: 5,
          dropdown: false
        },
        sortIcon: {
          is: ''
        },
        sortable: [],
        headings: {},
        templates: {},
        customSorting: {},
        orderBy: {},
        columnsClasses: {}
      },
      // pendingConciliaton data
      resultMov: {},
      resultExt: {},
      treeGridCfgMov: {},
      treeGridCfgExt: {},
      showTreegridMov: false,
      showTreegridExt: false,
      // allotments data
      resultLot: {},
      treeGridCfgLot: {},
      showTreegridLot: false,
      // selectedEntries data
      internalEntries: [],
      bankEntries: [],
      allotmentEntry: {},
      filterChanged: false,
      tabName: null,
      disableSearchButton: false,
      noPlanSelected: false,
      firstTimeBank: true,
      firstTimeEstab: true,
      planSelected: null,
      plans: [],
      disableSelectPlan: false,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      idsAccountsSelected: [],
      firstTimeAccount: true,
      firstTimeEstableshment: true,
      allotmentDetailsModalObj: null,
      filterable: [],
      attList: [],
      columnsFilterable: [],
      showCustomColumns: false,
      customSetOrder: null,
      filter: {
        entityId: null
      },
      isLoadingStatic: false,
      shown: {
        bankAccounts: false,
        categories: false
      },
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        },
        categories: {
          id: 'id',
          name: 'nome'
        }
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        categories: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todas')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              banco: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1
                }
              },
              agencia: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia
                  }
                  return a.numAgencia >= b.numAgencia
                }
              },
              conta: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1
                  }
                  return +a.conta <= +b.conta ? 1 : -1
                }
              }
            },
            templates: {
              nome: (h, row) => {
                let txt = row.nome
                if (!row.ativo) {
                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'
                }
                return txt
              },
              banco: (h, row) => {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome
                }
                return '-'
              },
              agencia: (h, row) => {
                let txt = '-'
                if (row.agencia) {
                  txt = row.numAgencia
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia
                  }
                }
                return txt
              },
              conta: (h, row) => {
                let txt = row.conta
                if (row.digConta) {
                  txt += '-' + row.digConta
                }
                return txt
              }
            }
          }
        },
        categories: {
          titles: {
            main: this.$t('categoria.titulos.titulo'),
            sub: this.$t('categoria.labels.selecionarCategoria')
          },
          selectedItems: [],
          columns: ['numero', 'nome', 'idContabil', 'tipo'],
          values: [],
          options: {
            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },
            perPage: 5,
            headings: {
              numero: this.$t('categoria.modal.labels.numero'),
              nome: this.$t('categoria.modal.labels.descricao'),
              idContabil: this.$t('categoria.modal.labels.idContabil'),
              tipo: this.$t('categoria.modal.labels.tipo')
            },
            filterable: ['numero', 'nome', 'idContabil', 'tipo'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['numero', 'nome', 'idContabil', 'tipo'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'numero'
            },
            customSorting: {
              numero: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.ordem >= b.ordem ? 1 : -1
                  }
                  return a.ordem <= b.ordem ? 1 : -1
                }
              },
              nome: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              idContabil: function (asc) {
                return function (a, b) {
                  const idA = a.idContabil
                  const idB = b.idContabil
                  if (idA === null || idB === null) {
                    if (asc) {
                      return idA === null ? -1 : 1
                    }
                    return idA === null ? 1 : -1
                  }
                  if (asc) {
                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase())
                  }
                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase())
                }
              },
              tipo: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase())
                  }
                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase())
                }
              }
            },
            templates: {
              idContabil: (h, row) => {
                return row.idContabil || '-'
              },
              tipo: (h, row) => {
                return this.$t(`categoria.modal.labels.${row.tipo}`)
              }
            }
          }
        }
      }
    }
  },

  computed: {
    showTabs () {
      return this.showTreegridExt && this.showTreegridMov
    },
    hasToUpdateMAnualConcilSearch () {
      return this.$store.getters.hasToUpdateMAnualConcilSearch
    },

    idRowMovFinRemoved () {
      return this.$store.getters.idRowMovFinRemoved
    },

    idRowBankStatRemoved () {
      return this.$store.getters.idRowBankStatRemoved
    },

    idRowAllotmentMovementRemoved () {
      return this.$store.getters.idRowAllotmentMovementRemoved
    },

    idRowAllotmentMovementAdded () {
      return this.$store.getters.idRowAllotmentMovementAdded
    },

    finMovAdded () {
      return this.$store.getters.finMovAdded
    },

    bankStatAdded () {
      return this.$store.getters.bankStatAdded
    },

    arrayConciliationPlan () {
      return this.$store.getters.arrayConciliationPlan
    },

    needSearchManualConciliationTransactions () {
      return this.$store.getters.needSearchManualConciliationTransactions
    },

    modalAllotmentDetails () {
      return {
        title: this.$t('conciliacaoManual.titulos.modalAllotmentDetailsTitle'),
        subtitle: this.$t('conciliacaoManual.titulos.modalAllotmentDetailsSubtitle')
      }
    },

    isLoadingDataActionsManualConciliation () {
      return this.$store.getters.isLoadingData
    },

    isLoadingDataActionsManualConciliationStatic () {
      return this.$store.getters.isLoadingStatic
    },

    arrayJustify () {
      return this.$store.getters.arrayJustify
    },

    idsFilterEstablishments () {
      return this.$store.getters.idsFilterEstablishments
    },

    loadingMessage () {
      return this.getKeyTranslated(this.$store.getters.loadingMessage)
    }
  },

  watch: {
    idRowMovFinRemoved () {
      if (window && window.Grids && window.Grids.ConcManualMovFin) {
        let row = window.Grids.ConcManualMovFin.GetRowById(this.$store.getters.idRowMovFinRemoved.id)
        if (!row) {
          row = _.findWhere(window.Grids.ConcManualMovFin.Rows, { IdMovimentacao: this.$store.getters.idRowMovFinRemoved.idMovimentacao })
        }
        if (row && (row.IdMovimentacao === this.$store.getters.idRowMovFinRemoved.idMovimentacao)) {
          window.Grids.ConcManualMovFin.ShowRow(row)
        }
      }
    },

    idRowBankStatRemoved () {
      if (window && window.Grids && window.Grids.ConcManualExtBan) {
        let row = window.Grids.ConcManualExtBan.GetRowById(this.$store.getters.idRowBankStatRemoved.id)
        if (!row) {
          row = _.findWhere(window.Grids.ConcManualExtBan.Rows, { IdLancamento: this.$store.getters.idRowBankStatRemoved.idLancamento })
        }
        if (row && (row.IdLancamento === this.$store.getters.idRowBankStatRemoved.idLancamento)) {
          window.Grids.ConcManualExtBan.ShowRow(row)
        }
      }
    },

    idRowAllotmentMovementAdded () {
      if (window && window.Grids && window.Grids.ConcManualLotes) {
        let row = window.Grids.ConcManualLotes.GetRowById(this.$store.getters.idRowAllotmentMovementRemoved)
        if (row) {
          window.Grids.ConcManualLotes.ShowRow(row)
        }
      }
    },

    // Percorre a lista de movimentos financeiros adicionados verificando se possui apenas lançamentos que não vieram no lote
    finMovAdded () {
      this.hasPendingLanc(this.$store.getters.finMovAdded, 'idMovimentacao', 'hasPendingFinMov')
      this.verifyAndShowAllotment()
    },

    // Percorre a lista do extrato bancário adicionado verificando se possui apenas lançamentos que não vieram no lote
    bankStatAdded () {
      this.hasPendingLanc(this.$store.getters.bankStatAdded, 'idLancamento', 'hasPendingBankStat')
      this.verifyAndShowAllotment()
    },

    hasToUpdateMAnualConcilSearch () {
      if (this.hasToUpdateMAnualConcilSearch) {
        this.configGridsAndSearch()
      }
    },

    needSearchManualConciliationTransactions () {
      if (this.$store.getters.bankStatAdded.needSearchManualConciliationTransactions) {
        this.search()
      }
    },

    arrayJustify () {
      if (this.arrayJustify.length > 0) {
        window.addEventListener('beforeunload', this.confirmExit)
      } else {
        window.removeEventListener('beforeunload', this.confirmExit)
      }
    }
  },

  methods: {
    resetFilter () {
      this.selectedEstablishments = []
      this.data.bankAccounts.selectedItems = []
      this.data.bankAccounts.considerInactiveAccounts = false
      this.data.categories.selectedItems = []
    },

    hasPendingLanc (arrayLancAdded, objectToFind, action) {
      let lancSelecMov = false
      arrayLancAdded.forEach(mov => {
        if (objectToFind in mov) {
          lancSelecMov = true
        }
      })

      this.$store.dispatch(action, lancSelecMov)
        .catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    verifyAndShowAllotment () {
      let lancSelecFinMovAllotment = true
      let lancSelecBankStatAllotment = true

      // Percorre o vetor de movimentos financeiros, caso tenha algum registro de algum lote, não vai voltar pra grid
      this.$store.getters.finMovAdded.forEach(mov => {
        if ('idLote' in mov) {
          lancSelecFinMovAllotment = false
        }
      })

      // Percorre o vetor de extrato bancário, caso tenha algum registro de algum lote, não vai voltar pra grid
      this.$store.getters.bankStatAdded.forEach(mov => {
        if ('idLote' in mov) {
          lancSelecBankStatAllotment = false
        }
      })

      // Se não tiver nenhum registro relacionado ao lote no último container, e ele estiver na grid, exibe novamente na grid
      if (lancSelecFinMovAllotment && lancSelecBankStatAllotment) {
        let idAllotment = this.$store.getters.idAllotment
        this.$store.dispatch('setIdAllotment', null)
          .then(() => {
            if (window && window.Grids && window.Grids.ConcManualLotes) {
              if (idAllotment) {
                let row = _.findWhere(window.Grids.ConcManualLotes.Rows, { IdLote: idAllotment })
                if (row) {
                  window.Grids.ConcManualLotes.ShowRow(row)
                  window.Grids.ConcManualLotes.Reload()
                }
              }
            }
          })
      }
    },

    badgerify (containerId, counter) {
      let badgeValue = document.createTextNode(counter)
      let badge = document.getElementById(containerId + '-badge')
      if (badge) {
        badge.textContent = counter
      } else {
        let tabSpan = document.querySelector('[aria-controls="' + containerId + '"]').childNodes[0]
        badge = document.createElement('b-badge')
        badge.className = 'badge badge-custom'
        badge.id = containerId + '-badge'
        badge.appendChild(badgeValue)
        tabSpan.appendChild(badge)
      }
    },

    removeBadge (containerId) {
      let badge = document.getElementById(containerId + '-badge')
      if (badge) {
        badge.remove()
      }
    },

    validate () {
      return new Promise(resolve => {
        this.$validator.validateAll().then((result) => {
          if (result && this.$refs.dateRange.validate()) {
            this.configGridsAndSearch().finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    configGridsAndSearch () {
      this.noPlanSelected = false
      this.showTreegridMov = true
      this.showTreegridExt = true
      this.showTreegridLot = true
      return this.search()
    },

    async search () {
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', false)
      this.disableSearchButton = true
      this.tabName = this.$t('conciliacaoManual.titulos.abaLancamentos')
      await this.verifyAndCleanAndSetConciliationPlan()
      await this.hideRowsGrids()
      await this.buildFilter()
      await this.startLoading()
      try {
        await this.searchTransactionsFormManualConciliation()
        return Promise.resolve()
      } catch (e) {
        return Promise.reject()
      }
    },

    verifyAndCleanAndSetConciliationPlan () {
      return new Promise((resolve, reject) => {
        let self = this
        // Verifica se foi modificado o plano de conciliação, caso tenha sido, limpa os valores previamente calculados
        if (self.$store.getters.arrayConciliationPlan && self.$store.getters.arrayConciliationPlan.length > 0) {
          let teste = _.indexOf(self.$store.getters.arrayConciliationPlan, this.idPlanSelected)
          if (teste === -1) {
            this.$store.dispatch('cleanEditState')
          }
        }
        // Seta no vuex o plano selecionado
        this.$store.dispatch('setArrayConciliationPlan', this.idPlanSelected).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    hideRowsGrids () {
      return new Promise((resolve, reject) => {
        let self = this
        window.Grids.OnRenderFinish = function (G) {
          G.ReloadBody()
          // Verifica se possui movimentações adicionadas no terceiro container
          if (self.$store.getters.finMovAdded && self.$store.getters.finMovAdded.length > 0) {
            self.$store.getters.finMovAdded.forEach(mov => {
              let row = _.findWhere(G.Rows, { IdMovimentacao: mov.idMovimentacao })
              if (row) {
                G.HideRow(row)
              }
            })
          }
          // Verifica se possui lançamentos bancários adicionadas no terceiro container
          if (self.$store.getters.bankStatAdded && self.$store.getters.bankStatAdded.length > 0) {
            self.$store.getters.bankStatAdded.forEach(mov => {
              let row = _.findWhere(G.Rows, { IdLancamento: mov.idLancamento })
              if (row) {
                G.HideRow(row)
              }
            })
          }
          G.RenderBody()
        }
        resolve()
      })
    },

    buildFilter () {
      return new Promise((resolve, reject) => {
        let inicio = this.dateRange.fromDate
        let fim = this.dateRange.toDate
        this.filter = {
          inicio: inicio,
          fim: fim,
          idsPlanosConciliacao: this.plansSelected.map(plan => plan['id']),
          idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),
          idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),
          considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
          idsCategorias: this.data.categories.selectedItems.map(selected => selected.id).filter(categories => categories !== '-1'),
          lang: language.getCookieByName('language')
        }
        this.filterChanged = true
        resolve()
      })
    },

    startLoading () {
      return new Promise((resolve, reject) => {
        startTreeGridLoading('#concManualMovFin')
        startTreeGridLoading('#concManualExtBanc')
        this.$store.dispatch('hasToUpdateMAnualConcilSearch', false).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchTransactionsFormManualConciliation () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchTransactionsForManualConciliation', this.filter)
          .then((response) => {
            window.DisposeGrids()
            this.treeGridCfgMov = response.data.treegrid.Cfg.Layout
            this.resultMov = response.data.treegrid
            this.treeGridCfgExt = response.data.treegridBankStat.Cfg.Layout
            this.resultExt = response.data.treegridBankStat
            this.buttonGridAddRowFinMov()
            this.buttonGridAddRowBankStat()
            this.stopLoadingAndConfigureBadge(response)
            resolve()
          }).catch((error) => {
            this.$root.$refs.notification.error(this.$t(error.message))
            stopTreeGridLoading('#concManualMovFin')
            stopTreeGridLoading('#concManualExtBanc')
            // document.querySelector('#pendingProtlet').scrollIntoView({ behavior: 'smooth' })
            this.disableSearchButton = false
            reject()
          })
      })
    },

    buttonGridAddRowFinMov () {
      window.Grids.addRowFinMov = (row) => {
        trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-mov-financeira', row.SituacaoConciliacao)

        row.isTreeGrid = true
        this.$store.dispatch('setFinMov', row)
          .then(() => {
            window.Grids.ConcManualMovFin.HideRow(row)
          }).catch((error) => {
            this.$root.$refs.notification.error(this.$t(error.message))
          })
      }
    },

    buttonGridAddRowBankStat () {
      window.Grids.addRowBankStat = (row) => {
        trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-extrato-bancario', row.SituacaoConciliacao)

        row.isTreeGrid = true
        this.$store.dispatch('setBankStat', row)
          .then(() => {
            window.Grids.ConcManualExtBan.HideRow(row)
          }).catch((error) => {
            this.$root.$refs.notification.error(this.$t(error.message))
          })
      }
    },

    stopLoadingAndConfigureBadge (response) {
      stopTreeGridLoading('#concManualMovFin')
      stopTreeGridLoading('#concManualExtBanc')

      response.data.pendingEntries && response.data.pendingEntries > 0
        ? this.badgerify('#tab-conciliacoes-pendentes', response.data.pendingEntries)
        : this.removeBadge('#tab-conciliacoes-pendentes')

      response.data.pendingAllotments && response.data.pendingAllotments > 0
        ? this.badgerify('#tab-lotes', response.data.pendingAllotments)
        : this.removeBadge('#tab-lotes')

      this.disableSearchButton = false
    },

    loadAllotments (tabIndex) {
      // Somente chama o serviço quando for a segunda aba (lotes) e quando o usuário clicar na busca novamente
      if (tabIndex === 1 && this.filterChanged) {
        this.disableSearchButton = true
        this.filterChanged = false
        this.showTreegridLot = true
        startTreeGridLoading('#concManualLotes')
        let self = this
        window.Grids.OnRenderFinish = function (G) {
          // Verifica se possui movimentações do lote adicionadas no terceiro container,
          // caso possua remove da grid
          if (self.$store.getters.idAllotment) {
            let row = _.findWhere(G.Rows, { IdLote: self.$store.getters.idAllotment })
            if (row) {
              G.HideRow(row)
            }
          }
        }
        // Chama a consulta de lotes
        this.getAllotments()
      }
    },

    getAllotments () {
      this.$store.dispatch('searchAllotments', this.filter)
        .then((allotmentsResponse) => {
          if (window.Grids.ConcManualLotes) {
            window.Grids.ConcManualLotes.DisposeGrids()
          }
          this.resultLot = allotmentsResponse.treegridAllotment.Cfg.Layout
          this.treeGridCfgLot = allotmentsResponse.treegridAllotment

          // Ação do botão da grid de lotes, que carrega os movimentos e adiciona no resumo
          this.loadAllotmentsMovements()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          stopTreeGridLoading('#concManualLotes')
          document.querySelector('#pendingProtlet').scrollIntoView({ behavior: 'smooth' })
          this.disableSearchButton = false
        })
    },

    loadAllotmentsMovements () {
      let self = this
      // Função para adição de lote
      window.Grids.getAllotmentMovements = (row) => {
        trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-lote', row.SituacaoConciliacao)

        this.$store.dispatch('setIdAllotment', row.IdLote)
          .then((response) => {
            let idAllotmentRemoved = self.$store.getters.idRowAllotmentMovementAdded
            let data = {
              'idAllotmentRemoved': idAllotmentRemoved,
              'row': row
            }
            this.$store.dispatch('getAllotmentMov', data)
              .then((response) => {
                window.Grids.ConcManualLotes.HideRow(row)
              }).catch((error) => {
                this.$root.$refs.notification.error(this.$t(error.message))
              })
          }).catch((error) => {
            this.$root.$refs.notification.error(this.$t(error.message))
          })
      }

      // Função para abertura da modal de detalhes
      window.Grids.openAllotmentDetailsModal = (row) => {
        // trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-lote', row.SituacaoConciliacao)
        self.allotmentDetailsModalObj = {
          idLote: row.IdLote,
          dtInicio: row.DtLancInicial,
          dtFim: row.DtLancFinal,
          totalMovBan: row.VlExtratoBancario,
          totalMovFin: row.VlMovimentoFinanceiro,
          situacao: row.SituacaoConciliacao
        }
        setTimeout(() => {
          self.$refs.tabAllotmentManualConcilModal.createAllotmentDetailsFromManualConcilaition()
          $('#detalhesLoteConcManual').modal({ backdrop: 'static', keyboard: false })
        }, 100)
      }
      stopTreeGridLoading('#concManualLotes')
      document.querySelector('#tab-navigation').scrollIntoView({ behavior: 'smooth' })
      this.disableSearchButton = false
    },

    saveAndClose () {
      switch (this.selectModal) {
        case this.CONCILIATION_PLAN_MODAL:
          this.plansTags = this.plansSelected.map(plan => plan['nome'])
          if (this.noPlanSelected) {
            this.noPlanSelected = false
            document.getElementsByClassName('vue-input-tag-wrapper')[0].style.border = '1px solid #CCC'
          }
          break
      }
      this.closeModal()
    },

    selectItem (item) {
      item.checked = !item.checked
      switch (this.selectModal) {
        case this.CONCILIATION_PLAN_MODALCONCILIATION_PLAN_MODAL:
          this.selectPlan(item)
          break
      }
    },

    selectPlan (plan) {
      if (plan === null) {
        return
      }
      this.idPlanSelected = plan.id
      this.plansSelected = []
      this.planSelected = plan
      this.plansSelected.push(plan)
    },

    loadPlans () {
      this.selectModal = this.CONCILIATION_PLAN_MODAL

      let url = '/manualConciliation/plans/list'
      this.$store.dispatch('getPlans', url).then((response) => {
        this.plans = response.data.data
        if (response.data.data.length === 1) {
          this.planSelected = response.data.data[0]
          this.selectPlan(this.planSelected)
          this.disableSelectPlan = true
        }
      })
    },

    openSelectBankAccountsModal () {
      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true
        return
      }
      this.$store.dispatch('getBankAccounts', '/manualConciliation/bankAccounts/list')
        .then(response => {
          this.data.bankAccounts.allBankAccounts = response.data.data
          this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {
            return !bankAccount.ativo
          })
          this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {
            return bankAccount.ativo
          })
          this.shown.bankAccounts = true
        })
    },

    openSelectCategoriesModal () {
      if (this.data.categories.values.length > 0) {
        this.shown.categories = true
        return
      }
      this.$store.dispatch('getCategories', {
        url: '/manualConciliation/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      })
        .then((response) => {
          this.data.categories.values = response.data
          this.shown.categories = true
        })
    },

    closeModal () {
      this.shown.bankAccounts = false
      this.shown.categories = false
    },

    closeAllotmentDetailsModal () {
      $('#detalhesLoteConcManual').modal('hide')
    },

    getKeyTranslated (key) {
      return this.$t(key)
    }
  },

  created () {
    this.messageExit = this.$t('conciliacaoManual.labels.alertJustificativa')
    this.$store.dispatch('cleanEditState')
    this.loadPlans()
  },

  beforeDestroy () {
    window.removeEventListener('beforeunload', this.confirmExit)
  }
}
</script>

<style scoped>
@import '../../../../../node_modules/vue-nav-tabs/themes/vue-tabs.css';
.isLoadingManualConciliationActionsStatic {
  background: url(../../../../assets/logos_equals/logo_equals_quadrado.svg) 50.5% 49% no-repeat;
  background-color: #EEE;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  opacity: 0.9;
  overflow-y: hidden;
  cursor: wait;
  background-size: 150px;
  -webkit-transition: all 5s ease-in-out;
  -moz-transition: all 5s ease-in-out;
  -ms-transition: all 5s ease-in-out;
  -o-transition: all 5s ease-in-out;
  transition: all 5s ease-in-out;
}

.isLoadingManualConciliationActions {
  background: url(../../../../assets/loading-gif/loading.svg) 50% 45% no-repeat;
  background-color: #EEE;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  opacity: 0.9;
  overflow-y: hidden;
  cursor: wait;
  background-size: 150px;
  -webkit-transition: all 5s ease-in-out;
  -moz-transition: all 5s ease-in-out;
  -ms-transition: all 5s ease-in-out;
  -o-transition: all 5s ease-in-out;
  transition: all 5s ease-in-out;
}

.spanLoading {
  color: #13556A;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 25px;
  position: fixed;
  top: 49%;
  margin-top: 60px;
  width: 100%;
  text-align: center;
}

#spin:after {
  content: '';
  animation: spin 5s linear infinite;
}

@keyframes spin {
  0% {
    content: attr(data-content);
  }
  100% {
    content: attr(data-content2);
  }
}

#tab-navigation {
  font-family: 'Inter', sans-serif;
}

.tab {
  margin-top: 20px;
}

.nav-tabs>li>a {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  text-transform: none;
}

.vue-tabs .nav>li span.title {
  color: #142C4F;
}

.vue-tabs .nav-tabs {
  border-bottom: 2px solid #d6e2f5;
}

.vue-tabs .nav-tabs>li>a {
  border: none;
}

.vue-tabs .nav>li.active span.title {
  color: #fff;
}

.vue-tabs .nav-tabs>li.active>a,
.vue-tabs .nav-tabs>li.active>a:hover,
.vue-tabs .nav-tabs>li.active>a:focus {
  border: none;
  border-top: 5px solid #3bb5b4;
  color: #fff;
  background: #142C4F;
  font-weight: 600;
  margin-bottom: -1px;
  padding-bottom: 11px;
}

.vue-tabs .nav-tabs>li>a,
.vue-tabs .nav-tabs>li>a:hover,
.vue-tabs .nav-tabs>li>a:focus {
  border: none;
  border-top: 5px solid #fff;
  color: #142C4F;
  background: #d6e2f5;
  font-weight: 600;
  margin-bottom: -1px;
  padding-bottom: 13px;
}

.pending-title-manual-conciliation {
  text-align: left;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  margin-top: 3vh;
  color: #17375f;
}

.grey-right-border {
  border-right: solid 2px #cccccc;
}

.pending-box {
  padding-right: 25px!important;
}

.pending-conciliation-box {
  display: grid;
}

.centered {
  text-align: center;
}

.badge-custom {
  padding: 7px 2px;
  margin-left: 1vh;
  background-color: #f55753 !important;
  border-radius: 50%;
  min-width: 30px;
  margin-top: 21px;
  right: 2px;
  z-index: 9;
  position: absolute;
}

p.placeholderInputTag {
  z-index: 3;
  position: absolute;
  padding: 7px 0px 0px 7px;
  color: #999;
}

button.filter-input-tag {
  width: 100%;
  min-width: auto;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// ManualConciliation.vue?302d855a